import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["club"]
  static values = { url: String }

  // When the club changes, reload the form frame scoped to the chosen club so
  // the activator dropdown repopulates with that club's activators. The server
  // renders the correct list (see BatchIoController#new_import).
  clubChanged() {
    const frame = document.getElementById("batch_form")
    if (!frame) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("club_id", this.clubTarget.value)
    frame.src = url.toString()
  }
}
